import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './langs/en';
import ja from './langs/ja';
import ko from './langs/ko';
import zh from './langs/zh';
import zt from './langs/zt';

export const Locale = {
  En: 'en',
  Ja: 'ja',
  Zh: 'zh',
  Zt: 'zt',
  Ko: 'ko'
} as const;

export type Locale = (typeof Locale)[keyof typeof Locale];

export const LOCALES = Object.values(Locale);
export const DEFAULT_LOCALE: Locale = Locale.Ja;

export const isLocale = (value: string): value is Locale =>
  (LOCALES as readonly string[]).includes(value);

const detectLocale = (): Locale => {
  if (typeof window === 'undefined') return DEFAULT_LOCALE;
  const [, segment = ''] = window.location.pathname.split('/');
  return isLocale(segment) ? segment : DEFAULT_LOCALE;
};

i18n.use(initReactI18next).init({
  returnNull: false,
  lng: detectLocale(),
  supportedLngs: LOCALES,
  resources: {
    en: {
      translation: {
        ...en
      }
    },
    ja: {
      translation: {
        ...ja
      }
    },
    zh: {
      translation: {
        ...zh
      }
    },
    zt: {
      translation: {
        ...zt
      }
    },
    ko: {
      translation: {
        ...ko
      }
    }
  }
});

export default i18n;
